import { CSSProperties, FC } from 'react';
import { ErrorMessage, Field, FieldInputProps } from 'formik';
import { Checkbox } from '@mantine/core';

interface FieldCheckboxProps {
    name: string;
    label: string;
    placeholder?: string;
    required?: boolean;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    style?: CSSProperties;
}

const FieldCheckbox: FC<FieldCheckboxProps> = ({
    name,
    label,
    required,
    size = 'md',
    style
}: FieldCheckboxProps) => {
    return (
        <>
            <Field name={name} type="checkbox">
                {({ field }: { field: FieldInputProps<boolean> }) => (
                    <Checkbox
                        label={label + (required ? ' *' : '')}
                        checked={field.value || false}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        id={field.name}
                        style={style}
                        size={size}
                    />
                )}
            </Field>
            <ErrorMessage name={name}>
                {msg => <span className="required">{msg}</span>}
            </ErrorMessage>
        </>
    );
};

export default FieldCheckbox;
